<template>
  <div class="ai-countdown" :class="{ 'ai-countdown--mobile': isMobile }">
    <vue-countdown :time="props.time" tag="div" v-slot="{ hours, minutes, seconds }" @end="endHandler">
      <div class="ai-countdown__item">
        <div class="ai-countdown__item__digits">
          <div v-if="String(hours).split('').length < 2" class="ai-countdown__item__digits__item">0</div>
          <div v-for="(item, index) in String(hours).split('')" :key="index" class="ai-countdown__item__digits__item">
            {{ item }}
          </div>
        </div>
        <div class="ai-countdown__item__label">{{ $t('countdown.hours') }}</div>
      </div>
      <div class="ai-countdown__divider">:</div>
      <div class="ai-countdown__item">
        <div class="ai-countdown__item__digits">
          <div v-if="String(minutes).split('').length < 2" class="ai-countdown__item__digits__item">0</div>
          <div v-for="(item, index) in String(minutes).split('')" :key="index" class="ai-countdown__item__digits__item">
            {{ item }}
          </div>
        </div>
        <div class="ai-countdown__item__label">{{ $t('countdown.minutes') }}</div>
      </div>
      <div class="ai-countdown__divider">:</div>
      <div class="ai-countdown__item">
        <div class="ai-countdown__item__digits">
          <div v-if="String(seconds).split('').length < 2" class="ai-countdown__item__digits__item">0</div>
          <div v-for="(item, index) in String(seconds).split('')" :key="index" class="ai-countdown__item__digits__item">
            {{ item }}
          </div>
        </div>
        <div class="ai-countdown__item__label">{{ $t('countdown.seconds') }}</div>
      </div>
    </vue-countdown>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { storeToRefs } from 'pinia';

import { useCommonStore } from '@/store/common';

import VueCountdown from '@chenfengyuan/vue-countdown';

const props = defineProps({
  time: {
    type: Number as PropType<number>,
    required: true,
  },
});

const { isMobile } = storeToRefs(useCommonStore());

const emits = defineEmits(['end']);

const endHandler = (): void => {
  emits('end');
};
</script>

<style scoped lang="scss" src="./AiCountdown.scss" />
